import { ModalBodyWrapper } from './AccountModal'
import { FieldCheckBox } from './FieldCheckBox'
import { useAccountLayoutContext } from './AccountProfileContext'

/**
 *
 * @param {{sports: string[],connectionId: number, handleToggle: () => void, selectedSports: string[], sports: any}} props
 * @returns
 */
export const FormAddSport = (props) => {
  const { omneoClient } = useAccountLayoutContext()
  return (
    <ModalBodyWrapper
      config={{
        submitButtonText: 'Save',
        handleToggle: props.handleToggle,
        submitCallback: async (e) => {
          e.preventDefault()
          try {
            const payload = []
            const data = new FormData(e.currentTarget)
            data.forEach((v, k) => {
              payload.push(v)
            })
            const child = omneoClient.client.profile.Connection(props.connectionId)
            await omneoClient.updateFavouriteSports(child, payload)
            props.handleRefetch()
            props.handleToggle()
          } catch (err) {
            console.log(err)
          }
        }
      }}
    >
      <div className={'grid grid-cols-2 gap-4'}>
        {props.sports.map((sport) => (
          <FieldCheckBox
            {...{
              name: sport.label,
              value: sport.value,
              required: false,
              checked: props.selectedSports.includes(sport.value)
            }}
          >
            <div className={'flex w-full items-center justify-center'}>
              <div className={'aspect-1 max-h-8 w-16'}>
                <img src={sport.icon} className={'h-full w-full object-contain'} />
              </div>
              <div>{sport.label}</div>
            </div>
          </FieldCheckBox>
        ))}
      </div>
    </ModalBodyWrapper>
  )
}
